<template>
  <v-app id="main">
    <div class="menu-header d-flex mb-5">
      <v-container class="d-flex">
        <v-row class="d-flex">
          <v-col class="d-flex" sm="3">
            <v-img
              src="https://upload.wikimedia.org/wikipedia/commons/9/9e/BDO_Deutsche_Warentreuhand_Logo.svg"
              class="main-logo"
            />
          </v-col>
          <v-col v-if="user" class="d-flex">
            <v-spacer></v-spacer>
            <v-select
              v-if="user_countries.length > 0"
              v-model="selected_country"
              :items="user_countries"
              class="ma-0 mr-2 pt-1 country-select"
              label="Country"
              item-text="name"
              item-value="id"
              dense
              outlined
              hide-details
              :loading="loading"
            ></v-select>
            <v-list class="d-flex flex-row ma-0 pa-0 menu-items">
              <v-list-item v-for="(link, i) in links" :key="i" :to="link.to">
                <span v-if="link.logout" @click="logout()">
                  {{ link.title }}
                </span>
                <span v-else>
                  {{ link.title }}
                </span>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <v-main>
      <slot />
    </v-main>
  </v-app>
</template>

<script>
import helpers from '@/plugins/helpers'
import { mapGetters } from 'vuex'
import config from '@/config'
export default {
  data: () => ({
    user_countries: [],
    selected_country: null,
    loading: false
  }),
  computed: {
    ...mapGetters({
      user: 'general/user',
      countrycode: 'general/countrycode'
    }),
    links() {
      if (!this.$route.meta.auth) return
      return [
        { title: 'HOME', to: `/${this.countrycode}/questionnaires` },
        { title: 'FAQ', to: `/${this.countrycode}/information` },
        { title: 'SIGN OUT', to: '/', logout: true }
      ]
    }
  },
  watch: {
    user() {
      if (this.user) {
        this.getUserCountries()
      }
    },
    selected_country() {
      this.changeActiveCountry()
    }
  },
  mounted() {},
  methods: {
    async getUserCountries() {
      if (!this.$route.meta.auth) return
      this.user_countries = []
      let query = `{
        oneWebuser(where:{id:{eq: ${this.user.id}}}){
          name
          activeCountry{
            id
            name
            code
          }
          webUserCountries{ 
            authorized
            country{
              name
              code
              id
            }
          }
          webRole{
            id
            name
          }
        }
      }`
      let result = await helpers.fetchGraph(query)
      if (result) {
        if (result.data.oneWebuser.activeCountry) {
          this.selected_country = result.data.oneWebuser.activeCountry
          this.$store.commit('general/SET_CURRENT_COUNTRY_CODE', result.data.oneWebuser.activeCountry.code)
        }
        let arr = []
        for (let i = 0; i < result.data.oneWebuser.webUserCountries.length; i++) {
          const element = result.data.oneWebuser.webUserCountries[i]
          if (element.authorized == true) arr.push(element.country)
        }
        this.user_countries = arr.sort((a, b) => (a.name > b.name ? 1 : -1))
      }
    },
    async changeActiveCountry() {
      if (isNaN(this.selected_country)) return
      let response
      this.loading = true
      response = await helpers.fetchApi(config.apiUrl + `user/change-country/${this.selected_country}`, 'get')
      if (response.message) {
        this.$store.commit('general/SET_LOADING', { state: false })
        this.$store.commit('general/SET_SNACKBAR', {
          msg: response.message,
          status: ' white',
          color: 'success'
        })
        let activeCountryCode
        for (let i = 0; i < this.user_countries.length; i++) {
          const user_country = this.user_countries[i]
          if (user_country.id == this.selected_country) activeCountryCode = user_country.code
        }
        this.$store.commit('general/SET_CURRENT_COUNTRY_CODE', activeCountryCode)

        setTimeout(() => {
          this.loading = false
          this.$router.push({ path: `/${activeCountryCode}/questionnaires` })
          location.reload()
        }, 1000)
      }
    },
    async logout() {
      this.$store.commit('general/SET_LOADING', { state: true })
      let response = await helpers.fetchApi(config.apiUrl + `logout`, 'get')
      if (response) {
        if (response.statusCode == 200) {
          setTimeout(() => {
            this.$store.commit('general/SET_USER', {})
            this.$store.commit('general/SET_CURRENT_COUNTRY_CODE', '')
            this.$store.commit('general/SET_LOADING', { state: false })
            window.location.href = response.redirect_url
          }, 4000)
        } else {
          setTimeout(() => {
            this.$store.commit('general/SET_USER', {})
            this.$store.commit('general/SET_CURRENT_COUNTRY_CODE', '')
            this.$store.commit('general/SET_LOADING', { state: false })
            window.location.href = response.redirect_url
          }, 4000)
        }
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/style/_variables.scss';
.menu-header {
  flex-direction: row;
  align-content: center;
  height: 70px;
  background-color: white;
  border-bottom: 1px solid #e7e7e7;
  margin-bottom: 20px;

  & .country-select {
    max-width: 200px;
  }

  & .menu-items {
    width: 300px;
    & a {
      justify-content: center;

      &:hover {
        background: $bdo-red;

        & span {
          color: white !important;
        }
      }
    }
  }
}

.v-toolbar__content {
  max-width: 1140px;
  width: 100%;
}

.main-logo {
  max-height: 50px;
  max-width: 125px;
}
</style>
